import { Component, ViewContainerRef } from '@angular/core';
import { Notification } from '../../models/notification/notification.model';
import { NotificationService } from '../../services/notification/notification.service';
import { NotificationEvent } from '../../models/events/notification-event.model';
import { Role } from '../../models/shared/role.model';
import { FormBuilder, FormGroup, FormArray, FormControl, ValidatorFn } from '@angular/forms';
import { NotificationRole } from '../../models/notification/notificationRole.model';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { RolePermissionService } from '../../services/role/role-permission.service';
import { Router } from '@angular/router';
@Component({
  selector: 'app-create-notification',
  templateUrl: './create-notification.component.html',
  styleUrls: ['./create-notification.component.css']
})
/** create-notification component*/
export class CreateNotificationComponent {
  public notification = new Notification();
  public customerTypes: Role[];
  public notificationEvents: NotificationEvent[];
  public bellIcon: any;
  public notificationTypes: string[];
  form: FormGroup;
  frm: FormGroup;
  fd = new FormData();
  IconfileToUpload: File;
  fileToUpload: File;
  public controls: FormControl[]=[];
  public  notificationControls: FormControl[]=[];
  roles = [];
  types = [];
  public inputElement: any;
  selectedSmallLogo: string;
  public notificationRoleList: NotificationRole[]=[];
  selectedSmallImage: string="";
  selectedTinyImage: string="";
  selectedTinLogo: string = "";
  icons: string[] = [];
  images: string[] = [];
  //public startDateElement: any;
  //public endDateElement: any;
  /** create-notification ctor */
  constructor(private readonly notificationService: NotificationService,
    private formBuilder: FormBuilder, private readonly toastr: ToastsManager, vcr: ViewContainerRef, private readonly rolePermissionService: RolePermissionService, private readonly router: Router) {
    this.checkPermission();
    this.toastr.setRootViewContainerRef(vcr);
    this.GetNotificationEvents();
    this.notification.isActive = true;
 
    this.notification.eventID = 0;
    this.notification.notificationType = "";
    // for mulitple Dynamic checkeboxes
    // For roles
    this.controls = this.roles.map(c => new FormControl(false));
    //this set to default checked
    //if (this.roles.length > 0) {
    //  this.controls[0].setValue(true);
    //}
    this.form = this.formBuilder.group({
      roles: new FormArray(this.controls, minSelectedCheckboxes(1))
    });
    // For Notification Types
    this.notificationControls = this.types.map(c => new FormControl(false));
    //this set to default checked
    //if (this.types.length > 0) {
    //  this.notificationControls[0].setValue(true);
    //}
    this.frm = this.formBuilder.group({
      types: new FormArray(this.notificationControls, minSelectedCheckboxes(1))
    });
    // For roles
    this.notificationService.GetCustomerTypes().subscribe(
      data => {
        this.customerTypes = data;
        for (var i = 0; i < this.customerTypes.length; i++) {
          this.roles.push({
            'id': this.customerTypes[i].roleID,
            'name': this.customerTypes[i].roleName
          });
        }
        this.controls = this.roles.map(c => new FormControl(false));
        //this set to default checked
        // this.controls[0].setValue(true);

        this.form = this.formBuilder.group({
          roles: new FormArray(this.controls, minSelectedCheckboxes(1))
        });
      });
    // For Notification Types
    this.notificationService.GetNotificationTypes().subscribe(
      data => {
        this.notificationTypes = data;
        for (var i = 0; i < this.notificationTypes.length; i++) {
          this.types.push({
            'id': this.notificationTypes[i],
            'name': this.notificationTypes[i]
          });
        }
        this.notificationControls = this.types.map(c => new FormControl(false));
        //this set to default checked
        //this.notificationControls[0].setValue(true);

        this.frm = this.formBuilder.group({
          types: new FormArray(this.notificationControls, minSelectedCheckboxes(1))
        });
      });

  }
  uploadSmallImage(file: FileList) {
    this.fileToUpload = file.item(0);
    let reader = new FileReader();
    reader.onload = (e: any) => {
      this.images.push(e.target.result);
      this.notification.image = this.images[0];
      this.selectedSmallImage = this.images[0];
    }
    reader.readAsDataURL(this.fileToUpload);
  }
  uploadTinyImage(file: FileList) {
    this.IconfileToUpload = file.item(0);
      let reader = new FileReader();
      reader.onload = (e: any) => {
        this.icons.push(e.target.result);
        this.notification.icon = this.icons[0];
        this.selectedTinyImage = this.icons[0];
      }
    reader.readAsDataURL(this.IconfileToUpload);
  }
  checkPermission() {
  this.rolePermissionService.GetRolePermissions("notification").subscribe(
      data => {
        if (data != null) {

          var create = data.filter(function (element) {
            return (element.action == "create");
          });

          if (create.length > 0) {

          }
          else {
            this.router.navigate(["/notification-list"]);
          }
        }
        else {
          this.router.navigate(["/notification-list"]);
        }
      }
    )
  }
  //GetCustomerTypes() {
  //  this.notificationService.GetCustomerTypes().subscribe(
  //    data => {
  //      this.customerTypes = data;
  //    }
  //  )
  //}
  //GetNotificationTypes() {
  //  this.notificationService.GetNotificationTypes().subscribe(
  //    data => {
  //      this.notificationTypes = data;
  //    }
  //  )
  //}
  GetNotificationEvents() {
    this.notificationService.GetNotificationActiveEvents().subscribe(
      data => {
        this.notificationEvents = data;
      }
    )
  }

  onSubmit() {
    //getting checkbox values
    const selectedRoleIds = this.form.value.roles
      .map((v, i) => v ? this.roles[i].id : null)
      .filter(v => v !== null);
    
    //getting checkbox values
    const selectedNotificationIds = this.frm.value.types
      .map((v, i) => v ? this.types[i].id : null)
      .filter(v => v !== null);

    //Insert Notification
    let type: string = "";
    for (var i = 0; i < selectedNotificationIds.length; i++) {
      type += "," + selectedNotificationIds[i];
    }
    this.notification.notificationType = type.substring(1);
    this.notificationService.AddNotification(this.notification).subscribe(data => {
      const notificationID = data.toString();
      //Insert Notification Role
      for (var i = 0; i < selectedRoleIds.length; i++) {
        const notificationRole = new NotificationRole();
        notificationRole.roleID = selectedRoleIds[i];
        notificationRole.notificationID = notificationID;
        // check Action values against each role
        let fieldname = "input-" + selectedRoleIds[i];
        this.inputElement = document.getElementById(fieldname) as HTMLElement;
        if (this.inputElement != null && this.inputElement.value != "") {
          notificationRole.action = this.inputElement.value;
          notificationRole.isAction = true;
        }
        this.notificationRoleList.push(notificationRole);
      }
      this.notificationService.AddNotificationRole(this.notificationRoleList);
      this.toastr.success('Notification saved successfully.', 'Success');
    });
   
    this.bellIcon = document.getElementById("bellIcon") as HTMLElement;
    if (this.bellIcon != null) {
      this.bellIcon.innerHTML = parseInt(this.bellIcon.innerHTML) + 1;
    }
    
  }
}
//For Dynamic Checkboxes
function minSelectedCheckboxes(min = 1) {
  const validator: ValidatorFn = (formArray: FormArray) => {
    const totalSelected = formArray.controls
      .map(control => control.value)
      .reduce((prev, next) => next ? prev + next : prev, 0);

    return totalSelected >= min ? null : { required: true };
  };

  return validator;
}



// WEBPACK FOOTER //
// ./src/app/notification-components/create-notification/create-notification.component.ts